import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from './primeng.module';
import {
  SomenteAlfanumericoDirective,
  SomenteNumerosDirective,
  SomenteLetrasDirective,
  SomenteDataDirective,
  CpfValidoDirective,
  CelularValidoDirective,
  EmailValidoDirective,
  CnpjValidoDirective,
  RgValidoDirective,
  FormatarDataDirective,
  CnpjCpfTextoDirective,
  PlacaTextoDirective,
  MascaraTelefoneDirective
} from './mascaras/mascaras.directive';
import { UploadArquivoComponent } from './componentes/upload-arquivo/upload-arquivo.component';
import { RouterLink } from '@angular/router';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    UploadArquivoComponent,
    ReactiveFormsModule,
    PrimengModule,
    SomenteAlfanumericoDirective,
    SomenteNumerosDirective,
    SomenteLetrasDirective,
    SomenteDataDirective,
    CpfValidoDirective,
    RgValidoDirective,
    CnpjValidoDirective,
    CelularValidoDirective,
    EmailValidoDirective,
    RouterLink,
    FormatarDataDirective,
    CnpjCpfTextoDirective,
    PlacaTextoDirective,
    MascaraTelefoneDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    UploadArquivoComponent,
    ReactiveFormsModule,
    PrimengModule,
    SomenteAlfanumericoDirective,
    SomenteNumerosDirective,
    SomenteLetrasDirective,
    SomenteDataDirective,
    CpfValidoDirective,
    CnpjValidoDirective,
    RgValidoDirective,
    CelularValidoDirective,
    EmailValidoDirective,
    RouterLink,
    FormatarDataDirective,
    CnpjCpfTextoDirective,
    PlacaTextoDirective,
    MascaraTelefoneDirective
  ],
})
export class SharedModule {}
export * from './utils/metodos';
